const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
})

/**
 * @param {string} a - string to compare
 * @param {string} b - string to compare
 * @returns {number} - result number
 */

// a > b => 1
// a === b => 0
// a < b => -1
const naturalCompare = (a: string, b: string) => collator.compare(a, b)

export default naturalCompare
